import * as React from 'react';
export const MPSvg = React.forwardRef(function MPSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M2 2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2Z',
      fill: '#43458B',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M3 8a5 5 0 1 0 10 0A5 5 0 0 0 3 8Zm1 0a4 4 0 1 1 8 0 4 4 0 0 1-8 0Z',
      fill: '#FCD669',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M9.5 5c0 .5 0 1-.5 1.5l.75 5.5c0 .55-.75 1-1.75 1s-1.75-.45-1.75-1L7 6.5c-.5-.5-.5-1-.5-1.5h3Z',
      fill: '#6D71A4',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M7.91 6.44a.1.1 0 0 1 .18 0l.56 1.71a.1.1 0 0 0 .08.06h1.8a.1.1 0 0 1 .06.17L9.13 9.44a.1.1 0 0 0-.03.1l.56 1.72a.1.1 0 0 1-.15.1l-1.46-1.05a.1.1 0 0 0-.1 0l-1.46 1.06a.1.1 0 0 1-.15-.1l.56-1.72a.1.1 0 0 0-.03-.1L5.4 8.37a.1.1 0 0 1 .05-.17h1.8a.1.1 0 0 0 .1-.06l.55-1.71Z',
      fill: '#F6F9FC',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M7.35 8.15a.1.1 0 0 1-.08.06h-1.8a.1.1 0 0 0-.06.17l1.46 1.06a.1.1 0 0 1 .03.1l-.56 1.72a.1.1 0 0 0 .15.1l1.46-1.05a.1.1 0 0 1 .1 0l1.46 1.06a.1.1 0 0 0 .15-.1L9.1 9.54a.1.1 0 0 1 .03-.1l1.46-1.07a.1.1 0 0 0-.05-.17h-1.8a.1.1 0 0 1-.1-.06l-.54-1.7a.1.1 0 0 0-.18 0l-.56 1.71Zm1.59-.3-.5-1.53a.46.46 0 0 0-.88 0l-.5 1.52h-1.6a.46.46 0 0 0-.27.84l1.3.94-.5 1.53c-.14.43.35.78.71.52l1.3-.95 1.3.95c.36.26.85-.1.71-.52l-.5-1.53 1.3-.94a.46.46 0 0 0-.27-.84h-1.6Z',
      fill: '#43458B',
    }),
  );
});
MPSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var MP = {
  category: 'flag',
  colorable: false,
  name: 'MP',
  svg: MPSvg,
};
